import './ellipsis.css';
export var ellipsis = '_oqqp1n0-3-15-1';